var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "header align-items-center mb-4", class: _vm.containerSize },
    [
      _c(
        "b-col",
        {
          staticClass: "d-flex align-items-center flex-row",
          attrs: { cols: "10" },
        },
        [
          _vm.backPath
            ? _c(
                "span",
                {
                  staticClass: "clickable my-auto pr-3",
                  on: { click: _vm.goBack },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("arrow_back"),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h2", { staticClass: "page-header" }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.subtitle
        ? _c("b-col", { attrs: { cols: "10" } }, [
            _c("h6", { staticClass: "grey-text text-darken-1" }, [
              _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    "),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }